import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './checkbox.module.scss';
import cx from 'classnames';
import { Icon } from '../icon';

type Props = {
  checked: boolean;
  onCheck: () => void;
  disabled?: boolean;
  ariaLabel?: string;
  tabIndex?: number;
};

const Checkbox = (props: Props) => {
  const { checked, onCheck, disabled = false, ariaLabel, tabIndex } = props;

  const [focused, setFocuset] = useState<boolean>(false);

  const checkboxStyle = cx(styles.checkbox, {
    [styles.focused]: focused,
    [styles.checked]: checked,
    [styles.disabled]: disabled,
  });

  return (
    <div className={styles.checkboxContainer}>
      <div className={checkboxStyle} onClick={onCheck}>
        {checked &&
          // <Icon content="checked" color="white" />
          'x'}
      </div>

      <input
        type="checkbox"
        aria-label={ariaLabel}
        role="checkbox"
        tabIndex={tabIndex}
        disabled={disabled}
        onClick={onCheck}
        defaultChecked={checked}
        onFocus={() => setFocuset(true)}
        onBlur={() => setFocuset(false)}
      />
    </div>
  );
};

export default Checkbox;
